/**
 * Enum for Dashboard Types
 * @readonly
 * @enum {name: {value: number}}
 */

export const DashboardTypeEnum = Object.freeze({ employee: 1, manager: 2, admin: 3, employeeSimple: 4 });
